import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Grid, Typography, units } from '@hbf/dsl';
import { ContentfulImg } from 'ha/modules/Contentful/components/ContentfulImg';
import { useSelector } from 'react-redux';
import { getCurrentLanguageCode } from 'ha/modules/LanguageSwitcher/selectors';
import { ValuePropositionData } from './types';

const useStyles = makeStyles()(theme => ({
  overflowHidden: {
    overflow: 'hidden',
  },
  text: {
    [theme.breakpoints.up('md')]: {
      textAlign: 'center',
    },
  },
  img: {
    maxHeight: units.rem(5),
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      maxHeight: units.rem(10),
    },
  },
  imgContainer: {
    [theme.breakpoints.down('md')]: {
      paddingRight: units.rem(1),
    },
    [theme.breakpoints.up('md')]: {
      paddingBottom: units.rem(1),
    },
  },
}));

export interface Props {
  valuePropositions: ValuePropositionData[];
}

export const VpTripple: React.FC<Props> = ({ valuePropositions }) => {
  const { classes } = useStyles();
  const lang = useSelector(getCurrentLanguageCode);

  return (
    <div className={classes.overflowHidden}>
      <Grid container spacing={5}>
        {valuePropositions.map(vp => {
          // Remove isString check after https://github.com/housinganywhere/src/pull/1505 got merged.
          const image = vp.imageAsset || { fields: { url: vp.image } };

          const desc = image.fields.description;
          const alt = desc ? desc[lang] || desc.en : '';

          return (
            <Grid
              item
              justifyContent="center"
              container
              xs={12}
              md={4}
              key={vp.description}
            >
              <Grid
                container
                item
                xs={3}
                md={12}
                justifyContent="center"
                className={classes.imgContainer}
              >
                <div>
                  <ContentfulImg
                    role="presentation"
                    src={image.fields.url}
                    alt={alt}
                    className={classes.img}
                    defaultSrc={image.fields.url}
                    sizes={{ xs: '320px' }}
                  />
                </div>
              </Grid>
              <Grid item xs={9} md={12} className={classes.text}>
                {vp.title && (
                  <Typography.H2 component="h3">{vp.title}</Typography.H2>
                )}
                <Typography.Paragraph>{vp.description}</Typography.Paragraph>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </div>
  );
};
